var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"tab-header"},[_vm._v(_vm._s(_vm.$t('pages.taskDetails.tabs.history')))]),_c('div',[_c('grid',{ref:"historyDatatable",attrs:{"source":_vm.gridDataSource,"name":_vm.gridName,"columns":_vm.gridColumns,"defaultOrder":[[4, 'asc']]}})],1),_c('blocking-loader',{attrs:{"show":_vm.showLoader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }